import AiPerformanceCardsWrapper from './ai-performance-cards-wrapper/ai-performance-cards-wrapper';
import SectionLayout from '@/layouts/section-layout/section.layout';
import styles from './ai-performance.module.scss';
import { AiPerformance } from '@/services/dashboard-service/dashboard.service.types';

interface AiPerformanceProps {
  aiPerformanceData?: AiPerformance;
  isPending: boolean;
}

export default function AiPerformanceSection({ aiPerformanceData, isPending }: AiPerformanceProps) {
  return (
    <SectionLayout sectionTitle="AI Performance" className={styles.layout}>
      <AiPerformanceCardsWrapper
        isLoading={isPending}
        aiPerformanceData={aiPerformanceData}
        aiPerformanceChart={aiPerformanceData?.chart}
      />
    </SectionLayout>
  );
}
